import { type CustomTooltipProps } from "ag-grid-react"
import { max } from "lodash"

import { IncomingStockCard } from "~/components/purchaseOrder/incomingOrders/IncomingStockCard"
import { Card } from "~/components/reusable/Card"

import HeaderTooltip from "./HeaderTooltip"

const LastIncomingStockTooltip = (props: CustomTooltipProps) => {
  if (props.location === "header") {
    return <HeaderTooltip {...props} />
  }
  const variantIds = props.node?.group ? props.value.variantIds : [props.data.variantId]
  const skuIds = props.node?.group ? undefined : props.data.skuIds
  const date = props.node?.group
    ? props.value?.date
    : max(props.data.incomingOrders.map((order: any) => order.expectedArrivalDate))
  return (
    <Card className="w-full">
      <IncomingStockCard
        variantIds={variantIds}
        skuIds={skuIds}
        dateRange={{ start: date, end: date }}
      />
    </Card>
  )
}

export default LastIncomingStockTooltip
